import _ from 'lodash'

import { store } from '@atredux/store'
import {
    setIhmIIBTokenInfo,
    setIsLoggedIn,
} from '@atredux/slices/ihmLoginTokenInfoSlice'
import {
    getIIBRefreshToken,
    getIIBIdToken,
    getTokenType,
} from '@atredux/selectors/ihmLoginTokenInfoSelector'
import { Exception } from '@amzn/ihm-associate-tools-js-lib'
import { cordovaExec } from '@services/CandyCaneService'
import { EnvironmentPluginConstants } from '@utils/Constants/EnvironmentPluginConstants'

export class IhmIdentityBrokerTokenProvider {

    public static getRefreshToken (): string {
        return getIIBRefreshToken(store.getState())
    }

    public static getIdToken (): string {
        return getIIBIdToken(store.getState())
    }

    public static getTokenType (): string {
        return getTokenType(store.getState())
    }

    public static async setToken (refreshToken: string, tokenType: string, idToken: string) {
        if (_.isEmpty(tokenType)) {
            throw new Exception({
                message: 'IhmIdentityBroker token type must be set.',
            })
        }

        store.dispatch(setIhmIIBTokenInfo({
            _ihmIIBRefreshToken: refreshToken,
            _ihmIIBIdToken: idToken,
            _tokenType: tokenType,
        }))

        await this.setIibTokenInAndroid(idToken)
    }

    public static isTokenSet (): boolean {
        return !_.isEmpty(IhmIdentityBrokerTokenProvider.getIdToken()) && !_.isEmpty(IhmIdentityBrokerTokenProvider.getTokenType())
    }

    public static async clear () {
        store.dispatch(setIhmIIBTokenInfo({
            _ihmIIBToken: null,
            _ihmIIBIdToken: null,
            _tokenType: null,
        }))
        await this.clearIibTokenFromAndroid()
    }

    private static async setIibTokenInAndroid (iibIdToken: String) {
        await cordovaExec(EnvironmentPluginConstants.ENVIRONMENT_PLUGIN_NAME,
            EnvironmentPluginConstants.ACTION_SET_IIB_TOKEN,
            [{ iibIdToken }])
    }

    private static async clearIibTokenFromAndroid () {
        await cordovaExec(EnvironmentPluginConstants.ENVIRONMENT_PLUGIN_NAME,
            EnvironmentPluginConstants.ACTION_CLEAR_SHAREDPREFS_KEY,
            [EnvironmentPluginConstants.IIB_ID_TOKEN_KEY])
    }
}
